// Consumption identity is rule-wide; recipe/quantity parameters are versioned.
// Keep this independent of React so the policy and form transitions are testable.

export function canEditRuleConsumptionIdentity(rule, { isNew = false, newVersionMode = false } = {}) {
  if (isNew) return true;
  // Fail closed with an older backend. A capability is not an authorization:
  // the service rechecks all business references inside the save transaction.
  return !newVersionMode
    && rule?.editor?.can_edit_identity === true
    && rule?.usage?.used === false
    && rule?.latestVersion?.usage?.can_edit === true;
}

export function ruleConsumptionIdentityChanged(form, rule) {
  if (!rule) return false;
  const beforeBasis = rule.latestVersion?.quantity_basis || "direct_product";
  const afterBasis = form.quantity_basis || "direct_product";
  const afterProduct = afterBasis === "direct_product" ? String(form.product_id || "") : "";
  return beforeBasis !== afterBasis || String(rule.product_id || "") !== afterProduct;
}

export function switchRuleConsumptionBasis(form, nextBasis) {
  if (!["direct_product", "working_solution"].includes(nextBasis) || nextBasis === form.quantity_basis) return form;
  // Never silently reuse a concentrate quantity as a preparation count (or the
  // reverse). Users explicitly choose the new product/recipe and its amount.
  return {
    ...form,
    quantity_basis: nextBasis,
    product_id: "",
    quantity: "",
    unit_code: "",
    concentration_percent: null,
    solution_definition_id: "",
    solution_execution_count: "1",
    location_id: "",
  };
}
